
'use strict'

let dom = {

    /*
        // EXAMPLE USAGE:
        let thumbnailContainer.addEventListener('click', onThumbContainerClick)

        function onThumbContainerClick(event) {
            let targetAttribute = 'data-btn-thumbnail'
            let matchedElem = dom.eventAttributeMatch(event.target, event.currentTarget, targetAttribute)
            if (matchedElem) onThumbnailClick(matchedElem)
        }

        // WHAT IT DOES:
        // check if event.currentTarget contains the target attribute
        // check if event.Target contains target attribute
        // check whether any of it's parents and ancestors contain the target attribute
        // returns the matched elem if there is one
        // returns null if no match is found
    */
    eventAttributeMatch(eventTarget, eventCurrentTarget, attribute) {
        let match = null
        
        if ( eventTarget.hasAttribute && eventTarget.hasAttribute(attribute) ) {
            match = eventTarget
            return match
        }

        if ( eventCurrentTarget.hasAttribute && eventCurrentTarget.hasAttribute(attribute) ) {
            match = eventCurrentTarget
            return match
        }

        let node = eventTarget.parentNode

        while (node !== null) {
            if (node.hasAttribute && node.hasAttribute(attribute)) {
                match = node
                return match
            }

            node = node.parentNode
        }

        return match
    }


}

export default dom




/** WEBPACK FOOTER **
 ** ./src/scripts/client/utilities/dom.js
 **/